import { render, staticRenderFns } from "./MainOrdersContainer.vue?vue&type=template&id=1768a590&scoped=true&"
import script from "./MainOrdersContainer.vue?vue&type=script&lang=js&"
export * from "./MainOrdersContainer.vue?vue&type=script&lang=js&"
import style0 from "./MainOrdersContainer.vue?vue&type=style&index=0&id=1768a590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1768a590",
  null
  
)

export default component.exports